var _defs, _path, _line, _line2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIDmelonLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f15b5c;}.cls-2{fill:#921b1d;}.cls-3{fill:#ee3025;}.cls-4{fill:#bb2026;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.87,100.2l-4.29-1.64c-32.31-11.81-65.36-13.27-76.92-13.4l-.89,0H120.12A23.43,23.43,0,0,0,111.6,87c-.41.21-.81.42-1.17.64l-1.85,1.76,133.35,65.8,103.38-52.89Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 294.58,
    y1: 137.07,
    x2: 296.99,
    y2: 138.27
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 239.53,
    y1: 152.11,
    x2: 241.93,
    y2: 153.31
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.74,91q-2.62,4.2-2.35,11.26t.26,13.37V423.21q0,5.76-.26,14.41t1.31,12.84a14.55,14.55,0,0,0,1.14,2.19l136-299.56L110.43,87.65A11.24,11.24,0,0,0,106.74,91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.86,111.53c-2.32-1.55-4.7-3.1-7.13-4.68a93.92,93.92,0,0,0-12-6.32c-.27-.11-.55-.23-.83-.33l-99,52.89L387.63,402.31A164.07,164.07,0,0,0,397,388.12q29.82-51.21,29.82-125a284.83,284.83,0,0,0-7.08-61.25,164.16,164.16,0,0,0-26.53-59.75,134.9,134.9,0,0,0-9.05-11.38A153.2,153.2,0,0,0,361.86,111.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.65,452.34a10.07,10.07,0,0,0,7.69,5.19l1.74.2h156c50.27,0,88.64-18.69,115.52-55.42L242.89,153.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDmelonLight);
export default __webpack_public_path__ + "static/media/IDmelonLight.fc57981ce7c5eed81735ec334561b484.svg";
export { ForwardRef as ReactComponent };